// Shared constants for the create-from-template wizard (Sub-project E2,
// Task 6). See docs/superpowers/specs/2026-07-26-governed-roles-e2-design.md
// §3 for the step list this drives.

// The one capability the control-check + governance step treat specially:
// adding it flags a role as carrying sensitive financial data (mirrors
// backend_go internal/authz.CapFinanceViewSensitive).
export const SENSITIVE_CAP = "finance.view_sensitive";

// Step 2 — "What needs to differ?" (spec §3.2). `value: "scope_only"` is the
// dead-end option: the wizard shows an exit note instead of continuing.
export const DIFFERS_OPTIONS = [
  {
    value: "capabilities",
    label: "Capabilities",
    helper: "This role needs different permissions than the template.",
  },
  {
    value: "data_visibility",
    label: "Data visibility",
    helper: "Same permissions, scoped to different data — a business unit, cost center, etc.",
  },
  {
    value: "approval_authority",
    label: "Approval authority",
    helper: "Same permissions, but with different approval limits.",
  },
  {
    value: "scope_only",
    label: "Nothing — I only need a different assignment scope",
    helper: "You don't need a new role for this — assign the existing template-derived role with a scope.",
  },
];

// Step 4 — review frequency select (spec §2: review_frequency_days).
export const REVIEW_FREQUENCY_OPTIONS = [
  { value: "90", label: "Every 90 days" },
  { value: "180", label: "Every 180 days" },
  { value: "365", label: "Every 365 days" },
  { value: "none", label: "No scheduled review" },
];

// Step 4 — default-authority object types. Mirrors the single meaningful
// object type the approvals surface (DelegationsPage) already offers;
// role_default_authority.object_type isn't a server-enforced enum, but this
// keeps the picker concrete rather than a free-text field.
export const AUTHORITY_OBJECT_TYPE_OPTIONS = [
  { value: "budget_period_version", label: "Budget period version" },
];

export const WIZARD_STEPS = [
  { key: "name", label: "Name & purpose" },
  { key: "differs", label: "What needs to differ?" },
  { key: "capabilities", label: "Review capabilities" },
  { key: "governance", label: "Configure governance" },
  { key: "control", label: "Control check" },
];
